export default __webpack_public_path__ + "static/PEDAGOG_JE_POKLIC-34bec0ac274d1001c6204ae6caf7b986.png";